import NetworkLogic from "../../Shared/NetworkLogic";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RechargeCourse extends cc.Component {

    @property(cc.PageView)
    pageV: cc.PageView = null;
    @property(cc.Node)
    page: cc.Node = null;
    @property(cc.Node)
    content: cc.Node = null;
    @property(cc.Label)
    labText : cc.Label = null;
    private data = [];

    start () {

    }

    /**
     * [{…}]
     0:
     name: "图片0"
     text: "222aaa修改为vip"
     url: "http://api.fanyirong.com:8080/group1/zonghe/c934afe2958e8f1af1d1a372ca558
     * @param rec
     */
    updateUI(rec){
        let data = JSON.parse(rec);
        cc.log("===教程数据data:",data);
        this.data = data;
        //this.content.destroyAllChildren();
        this.pageV.removeAllPages();
        for (let i = 0;i < data.length;i++){
            let page = cc.instantiate(this.page);
            page.active = true;
            this.pageV.addPage(page);
            this.pageV.setCurrentPageIndex(i);
        }
        this.labText.string = data[0].text;

        this.pageV.scrollToPage(0,0.1);
        for (let i = 0;i < data.length;i++){
            let page = this.content.children[i];
            cc.loader.load(data[i].url, function (err, texture) {
                if (!err && this.node) {
                    if (cc.isValid(page)) {
                        page.getChildByName("logo").active = false;
                        page.getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture);
                    }
                } else {
                    cc.log("===加载教程图片错误");
                }
            }.bind(this))
        }
    }

    onBtnLeft(){
        let index = this.pageV.getCurrentPageIndex() - 1;
        cc.log("====index:",index);
        index = index < 0 ? 0 : index;
        this.labText.string = this.data[index].text;

        this.pageV.scrollToPage(index,0.3);
    }

    onBtnRight(){
        let index = this.pageV.getCurrentPageIndex() + 1;
        if (index > this.pageV.getPages().length - 1 ){
            index = this.pageV.getPages().length - 1;
        }
        this.labText.string = this.data[index].text;

        this.pageV.scrollToPage(index,0.3);
    }

    onBtnClose(){
        this.node.active = false;
    }
}